// viewers views
import { lazy } from "react";

export const DocumentViewerView = lazy(() => import("./DocumentViewerView"));
export * from "./annotation";
